// extracted by mini-css-extract-plugin
export default {"gratuity-header":"GratuityReport_gratuity-header__Ie+Mf","divider":"GratuityReport_divider__xyhNn"};